// src/routes/routes.js
import LoginContainer from '../content/LoginContainer';
import {
  CoursesEditContainer,
  CoursesTableContainer,
  CoursesCreationContainer,
} from '../content/CoursesContainer';
import {
  PillarEditContainer,
  PillarTableContainer,
  PillarCreationContainer,
} from '../content/PillarContainer';
import {
  MassiveMailsTableContainer,
  MassiveMailCreationContainer,
} from '../content/MasiveMails';
import {
  SessionTableContainer,
  SessionDetailsContainer,
  SessionCreationContainer,
} from '../content/SessionContainer';
import {
  UserTableContainer,
  UserEditContainer,
  UserCreationContainer,
} from '../content/UserContainer';
import SettingEditContainer from '../content/SettingContainer/SettingEditContainer';

import { ConvocatoriasList, ConvocatoriaPostulantesList, ConvocatoriaEditor } from '../content/PremioContainer';
import { ReportsList as ReporteriaList, ReportCreateContainer } from '../content/ReporteriaContainer';
import DashboardContainer from '../content/DashboardContainer';
import CatalogContainer from '../content/CatalogContainer';
import CatalogDetailContainer from '../content/CatalogContainer/CatalogDetailContainer';
import {
  ClientContainer,
  ClientCreation,
  ClientEditContainer,
  ClientInfoContainer,
  Container,
} from '../content/ClientContainer';
import { ProjectCreationContainer } from '../content/ProjectsContainer';
import ProjectInfoContainer from '../content/ProjectsContainer/ProjectInfoContainer';
import { NewsCreation, NewsList } from '../content/NewsContainer';
import NewsEdition from '../content/NewsContainer/newsEdition';
import AddAnnouncementUser from '../content/AnnouncementContainer/AnnouncementNewUser';
import WorkShopContainer from '../content/WorkShopContainer';
import WorkShopEdition from '../content/WorkShopContainer/components/WorkshopEdition';
import WorkShopHistory from '../content/WorkShopContainer/WorkShopHistory';
import WorkShopCreation from '../content/WorkShopContainer/components/WorkshopCreation';
import { SurveyContainer } from '../content/SurveyContainer';
import SurveyCreate from '../content/SurveyContainer/SurveyCreate';
import SurveyEditContainer from '../content/SurveyContainer/SurveyEditContainer.js';
import ReportEditContainer from '../content/ReporteriaContainer/ReportEditContainer';

// Importaciones de componentes para la nueva sección de Reportería (placeholders por ahora)
// Este componente se puede eliminar ya que ahora tenemos el componente real
// const ReporteriaCreationContainer = () => <div>Creación de Reportes - Próximamente</div>;
const ReporteriaEditContainer = () => <div>Edición de Reportes - Próximamente</div>;

const routes = [
  {
    path: '/',
    component: LoginContainer,
    isPublic: true,
    restricted: true,
    exact: true,
    title: 'Inicio de sesion',
  },
  {
    path: '/premio',
    component: ConvocatoriasList,
    exact: true,
    title: 'Premio',
  },
  {
    path: '/premio/crear',
    component: ConvocatoriaEditor,
    exact: true,
    title: 'Crear Premio',
  },
  {
    path: '/premio/:convocatoriaId/editar',
    component: ConvocatoriaEditor,
    exact: true,
    title: 'Editar Premio',
  },
  {
    path: '/premio/:convocatoriaId/postulaciones',
    component: ConvocatoriaPostulantesList,
    exact: true,
    title: 'Postulaciones de Convocatoria',
  },
  {
    path: '/clientes',
    component: ClientContainer,
    exact: true,
    title: 'Clientes',
  },
  {
    path: '/clientes/crear',
    component: ClientCreation,
    exact: true,
    title: 'Crear cliente',
  },
  {
    path: '/clientes/editar',
    component: ClientEditContainer,
    exact: true,
    title: 'Editar cliente',
  },
  {
    path: '/clientes/detalles',
    component: ClientInfoContainer,
    exact: true,
    title: 'Detalle del cliente',
  },
  {
    path: '/clientes/detalles/proyecto/',
    component: ProjectInfoContainer,
    exact: true,
    title: 'Proyecto',
  },
  {
    path: '/clientes/detalles/proyecto/editar',
    component: ProjectCreationContainer,
    exact: true,
    title: 'Proyecto',
  },
  {
    path: '/clientes/:name/convocatoria',
    component: ProjectCreationContainer,
    exact: true,
    title: 'Crear convocatoria cliente',
  },
  {
    path: '/clientes/reunion/nueva',
    component: SessionCreationContainer,
    exact: true,
    title: 'Nueva reunión',
  },

  {
    path: '/clientes/detalles/proyecto/agregar',
    component: AddAnnouncementUser,
    exact: true,
    title: 'Convocatorias',
  },
  {
    path: '/cursos',
    component: CoursesTableContainer,
    exact: true,
    title: 'Cursos',
  },
  {
    path: '/cursos/crear',
    component: CoursesCreationContainer,
    exact: true,
    title: 'Crear curso',
  },
  {
    path: `/cursos/editar/:courseId`,
    component: CoursesEditContainer,
    exact: true,
    title: 'Editar curso',
  },
  {
    path: '/novedades',
    component: NewsList,
    exact: true,
    title: 'Novedades',
  },
  {
    path: '/novedades/crear',
    component: NewsCreation,
    exact: true,
    title: 'Novedades',
  },
  {
    path: '/novedades/editar',
    component: NewsEdition,
    exact: true,
    title: 'Novedades',
  },

  {
    path: '/catalogo',
    component: CatalogContainer,
    exact: true,
    title: 'Catálogo',
  },
  {
    path: '/catalogo/detalle/:userId',
    component: CatalogDetailContainer,
    exact: true,
    title: 'Detalle de postulación',
  },
  {
    path: '/correos',
    component: MassiveMailsTableContainer,
    exact: true,
    title: 'Correos Masivos',
  },
  {
    path: '/correos/crear',
    component: MassiveMailCreationContainer,
    exact: true,
    title: 'Crear Correo Masivo',
  },
  {
    path: '/pilares',
    component: PillarTableContainer,
    exact: true,
    title: 'Pilares',
  },
  {
    path: '/pilares/crear',
    component: PillarCreationContainer,
    exact: true,
    title: 'Crear pilar',
  },
  {
    path: '/pilares/editar',
    component: PillarEditContainer,
    exact: true,
    title: 'Editar pilar',
  },

  {
    path: '/reuniones',
    component: SessionTableContainer,
    exact: true,
    title: 'Reuniones',
  },
  {
    path: '/reuniones/detalle',
    component: SessionDetailsContainer,
    exact: true,
    title: 'Detalle de la reunión',
  },
  {
    path: '/usuarios',
    component: UserTableContainer,
    exact: true,
    title: 'Usuarios',
  },
  {
    path: '/usuarios/editar',
    component: UserEditContainer,
    exact: true,
    title: 'Editar usuario',
  },
  {
    path: '/usuarios/crear',
    component: UserCreationContainer,
    exact: true,
    title: 'Editar usuario',
  },
  {
    path: '/configuraciones',
    component: SettingEditContainer,
    exact: true,
    title: 'Configuraciones',
  },
  {
    path: '/reporteria',
    component: ReporteriaList,
    exact: true,
    title: 'Reportería',
  },
  {
    path: '/reporteria/crear',
    component: ReportCreateContainer,
    exact: true,
    title: 'Crear Reporte',
  },
  {
    path: '/reporteria/editar/:reportId',
    component: ReportEditContainer,
    exact: true,
    title: 'Editar Reporte',
  },
  {
    path: '/dashboard',
    component: DashboardContainer,
    exact: true,
    title: 'Dashboard',
  },
  {
    path: '/formacion',
    component: WorkShopContainer,
    exact: true,
    title: 'Formación',
  },
  {
    path: '/talleres',
    component: WorkShopHistory,
    exact: true,
    title: 'Historial de talleres',
  },
  {
    path: '/talleres/crear',
    component: WorkShopCreation,
    exact: true,
    title: 'Crear Taller',
  },
  {
    path: `/talleres/editar`,
    component: WorkShopEdition,
    exact: true,
    title: 'Editar Taller',
  },
  {
    path: `/encuestas`,
    component: SurveyContainer,
    exact: true,
    title: 'Encuestas',
  },
  {
    path: `/encuestas/crear`,
    component: SurveyCreate,
    exact: true,
    title: 'Encuestas',
  },
  {
    path: `/encuestas/editar`,
    component: SurveyEditContainer,
    exact: true,
    title: 'Encuestas',
  },

];
export default routes;
